module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-5-4b804ca4e3993d343d6cefa294098cd6.png";